export default     {
    path: 'lkk-user-api',
    name: 'lkkUserApi',
    component: () => import(/* webpackChunkName: "lkkUserApi" */ '@/views/admin/LkkUserApi/index.vue'),
}
